import React, { Component }from 'react';
import $ from 'jquery';
import  '../css/firstScreen.css';
export default class FirstScreen extends Component{
    constructor(props) {
            super(props);
            this.state = {
              data:this.props.msg//首屏数据
            };
    }
    componentWillMount() { //组件初始化时只调用，以后组件更新不调用，整个生命周期只调用一次，此时可以修改state。

    }
    componentDidMount() {//组件渲染之后调用，只调用一次。

    }

    render(){
      const {data} = this.state;
      console.log(data);
        return(
            <div>
               {
                  data.map((key,i)=>{
                    let styles = {
                        marginTop:key.posY / 100 +"rem",
                        marginLeft:key.posX / 100 + "rem",
                        width:key.positionPicWeight / 100 + "rem",
                        height:key.positionPicHeight / 100 + "rem",
                        border:".03rem solid "+key.borderColor+"",
                        background:"url("+key.positionPic+") no-repeat",
                        backgroundSize:"100% 100%",
                        padding:""+parseInt(key.paddingY) / 100+"rem "+parseInt(key.paddingX) / 100+"rem"
                    };
                    return(
                      <div key={i} data-json={JSON.stringify(key)} style={styles} className="topic-firstScreen"  data-role="Widget">

                      </div>
                    )
                  })
                }

            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/component/firstScreen.js